import { Transition } from "@headlessui/react";
import moment from "moment";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import forgot from "../../assets/images/icon_login/forgot-password.svg";
import { setLoading } from "../../core/feature/config/configSlice";
import { forgotPassword } from "../../core/service/api_profile";
import TabsMobile from "../__template/TabsMobileComponent";

const ComponentForgotPasswordConfirmation = () => {
  const [sender, setSender] = useState("WA");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendOTP = async () => {
    if (sender == "WA" && phone == "")
      return toast.warning(t("LOGIN.warningWA"));
    if (sender != "WA" && email == "")
      return toast.warning(t("LOGIN.warningEmail"));

    var query = {
      newPassword: "",
      otp: "",
      phoneEmail: sender == "WA" ? phone : email,
      sendVia: sender.toLowerCase(),
      reqTime: moment().format("HH:mm"),
    };
    dispatch(setLoading(true));
    forgotPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        navigate("/forgot-password-otp", {
          state: { data: JSON.stringify(query) },
        });
      })
      .catch((err: any) => {
        console.log(err.status);

        dispatch(setLoading(false));
      });
  };
  return (
    <div className="min-h-screen h-full px-10 py-7 bg-psp-primary">
      <TabsMobile
        name={`${t("FORGOT-PASSWORD.title")}`}
        backUrl={"login"}
      ></TabsMobile>

      <section className="flex flex-col mt-6">
        {/* <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
          Reset Password
        </h1>
        <p className="font-montserrat mt-2 font-medium text-xs text-black text-center">
          Kami telah mengirim 6 digit kode. Silahkan masukan untuk mereset
          passwordmu
        </p>
        <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
          Masukkan Kode
        </h1>
        <hr /> */}
        <h1 className="font-montserrat m-0 font-medium text-sm text-black text-center">
          {t("FORGOT-PASSWORD-CONFIRMATION.subtitle")}
        </h1>
        <div className="flex flex-col gap-2 mt-3">
          <div className="flex flex-row gap-2">
            <input
              type="radio"
              name="autoLogin"
              value="WA"
              id="WA"
              checked={sender == "WA"}
              onChange={(e) => setSender(e.target.value)}
            />
            <label
              htmlFor="WA"
              className="font-montserrat text-sm font-light"
              onClick={() => setSender("WA")}
            >
              {t("FORGOT-PASSWORD-CONFIRMATION.viaWA")}
            </label>
          </div>
          <input
            hidden={sender != "WA"}
            onChange={(e) => setPhone(e.target.value)}
            className="px-3 py-2 rounded-lg ml-5"
          />
          <div className="flex flex-row gap-2">
            <input
              type="radio"
              name="autoLogin"
              value="EMAIL"
              id="EMAIL"
              onChange={(e) => setSender(e.target.value)}
            />
            <label
              htmlFor="EMAIL"
              className="font-montserrat text-sm font-light"
              onClick={() => setSender("EMAIL")}
            >
              {t("FORGOT-PASSWORD-CONFIRMATION.viaEmail")}
            </label>
          </div>
          <input
            hidden={sender != "EMAIL"}
            onChange={(e) => setEmail(e.target.value)}
            className="ml-5 px-3 py-2 rounded-lg"
          />
        </div>
        <button
          onClick={() => sendOTP()}
          className="mt-4 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
        >
          {t("FORGOT-PASSWORD-CONFIRMATION.sendOTP")}
        </button>
      </section>
    </div>
  );
};

export default ComponentForgotPasswordConfirmation;
